/* HSC out-of-stock sink — Nada app replacement (GROWTH LAYER theme, AU + US).
 *
 * 1. Sink: sold-out product cards drop to the bottom of the collection grid.
 *    This theme flags sold-out via a .badge-box--sold-out child (no data-available attr).
 * 2. Anchor: the in-grid promotional banner is re-seated so it sits directly
 *    below the last in-stock product.
 *
 * Why (2) exists: the banner's slot is hard-coded server-side in the collection
 * section ("render after product #4"). Once step 1 moves sold-out products past
 * it, in-stock products get stranded BELOW the banner and the first row is left
 * with empty columns. Re-anchoring makes the banner the divider between "in
 * stock" and "sold out", so the in-stock rows stay full whatever the stock
 * position happens to be that day.
 *
 * Defensive: only ever re-orders existing nodes; never hides or removes.
 * Idempotent — a second pass writes nothing, so the MutationObserver can't loop.
 * Re-runs after Ella's AJAX filter/sort/paginate swaps the grid.
 */
(function () {
  "use strict";

  var BUSY = false;

  function isSold(n) {
    return !!n.querySelector('.badge-box--sold-out, [class*="sold-out"]');
  }

  function items(grid) {
    return Array.prototype.slice.call(grid.querySelectorAll("[data-grid-item]"));
  }

  function sink(grid, nodes) {
    if (nodes.length < 2) return;
    for (var i = 0, seenSold = false; i < nodes.length; i++) {
      if (isSold(nodes[i])) {
        seenSold = true;
      } else if (seenSold) {
        nodes.forEach(function (n) {
          if (isSold(n)) grid.appendChild(n);
        });
        return;
      }
    }
  }

  function anchorBanner(grid, nodes) {
    var banner = grid.querySelector(".collection-banner-item");
    if (!banner || banner.parentNode !== grid) return;

    var firstSold = null;
    for (var i = 0; i < nodes.length; i++) {
      if (isSold(nodes[i])) { firstSold = nodes[i]; break; }
    }

    if (!firstSold) return;                              // nothing sold out — leave Liquid's slot
    if (firstSold === nodes[0]) return;                  // nothing in stock — leave Liquid's slot
    if (banner.nextElementSibling === firstSold) return; // already correct — no DOM write

    grid.insertBefore(banner, firstSold);
  }

  function run() {
    var grid = document.getElementById("CollectionLoop");
    if (!grid || BUSY) return;
    BUSY = true;
    try {
      sink(grid, items(grid));
      anchorBanner(grid, items(grid));
    } catch (e) {}
    BUSY = false;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  try {
    var target =
      document.querySelector("[data-products-grid]") ||
      (document.getElementById("CollectionLoop") || {}).parentNode;
    if (target && window.MutationObserver) {
      new MutationObserver(function () {
        if (!BUSY) window.requestAnimationFrame(run);
      }).observe(target, { childList: true, subtree: true });
    }
  } catch (e) {}
})();
